module.exports = __webpack_public_path__ + "0c62dbe4d810b889750c171725021bc8.pdf";